import React, { useState } from 'react';
import './FAQComponent.scss';

const categories = [
  { label: 'ALL QUESTIONS', value: 'all' },
  { label: 'PRESCRIPTION', value: 'prescription' },
  { label: 'CLEAR LENSES', value: 'clear' },
  { label: 'COLOUR LENSES', value: 'colour' },
  { label: 'EXCHANGES', value: 'exchanges' },
  { label: 'DELIVERY', value: 'delivery' },
];

const FAQ_DATA = {
  all: [
    {
      q: 'How do I find my prescription?',
      a: 'You can check your latest prescriptions here. Alternatively, you could schedule a free consultation with one of our optometrists. <br/><br/><a href="/stores/sg " class="faq-link faq-link-arrow">Book your free consultation</a>',
    },
    {
      q: 'When will my contact lens prescription expire?',
      a: 'Contact lens prescription will expire 1 year from the issued date. We offer free contact lens prescription renewal. <br/><br/><a href="/stores/sg " class="faq-link faq-link-arrow">Book your free consultation</a>',
    },
    {
      q: 'How long can I wear Clear Vision lenses?',
      a: 'Clear Vision lenses offer 12-16 hours of daily comfortable wear. However, individual performance may vary depending on eye conditions, environmental factors, and frequency of use.',
    },
    {
      q: 'Where are our clear lenses manufactured from?',
      a: 'They are proudly manufactured in Singapore',
    },
    {
      q: 'Do we offer trial clear lenses?',
      a: 'We do offer trial lenses for our Clear vision lenses. Visit our <a href="/stores/sg " class="faq-link">selected retail stores</a> to get them! <br/>Depending on your frequency choice we offer the following trials:<br/><div class="faq-bullet-point">Monthly Clear  - 1 Pair (2pcs) - 10 day usage</div> <div class="faq-bullet-point">Daily Clear - 5 pairs (10pcs) - 5 day usage</div> <div class="faq-bullet-point">Daily Blue - 5 pairs (10pcs) - 5 day usage</div>',
    },
    {
      q: 'How long can I wear these colour lenses?',
      a: 'Horoscope and Petal lenses offer 8 hours of comfortable wear. However, individual performance may vary depending on eye conditions, environmental factors, and frequency of use.',
    },
    {
      q: 'Where are our colour lenses manufactured from?',
      a: 'They are manufactured in Korea',
    },
    {
      q: 'Do we offer trial colour lenses?',
      a: 'Currently, we do not offer trial lenses for our colour contacts',
    },
    {
      q: 'When do we allow exchanges?',
      a: '<div class="faq-bullet-point">Manufacturing defects</div> <div class="faq-bullet-point">Prescription changes (Unopen boxes, more than 1 year of expiry)</div> <div class="faq-bullet-point">All exchanges has to be done in <a href="/stores/sg " class="faq-link">selected retail stores</a></div>',
    },
    {
      q: 'Are there any contact lens deals?',
      a: 'Yes we do offer the following Bundle Deal Discounts:<br/><div class="faq-bullet-point">For Clear Vision Daily, Monthly and Blue</div> <div class="faq-bullet-point-sub">$10 Off for every 4 Boxes purchased</div> <div class="faq-bullet-point-sub">$30 Off for every 8 Boxes purchased</div> <div class="faq-bullet-point">For Colour lenses</div> <div class="faq-bullet-point-sub">Receive 1 box free for every 7 boxes purchased</div>',
    },
    {
      q: 'Do you offer free shipping?',
      a: 'Yes, shipping is free for orders over S$50.',
    },
    {
      q: 'How long does delivery take?',
      a: '1-2 business days',
    },
  ],
  prescription: [
    {
      q: 'How do I find my prescription?',
      a: 'You can check your latest prescriptions here. Alternatively, you could schedule a free consultation with one of our optometrists. <br/><a href="/stores/sg " class="faq-link faq-link-arrow">Book your free consultation</a>',
    },
    {
      q: 'When will my contact lens prescription expire?',
      a: 'Contact lens prescription will expire 1 year from the issued date. We offer free contact lens prescription renewal. <br/><br/><a href="/stores/sg " class="faq-link faq-link-arrow">Book your free consultation</a>',
    },
  ],
  clear: [
    {
      q: 'How long can I wear Clear Vision lenses?',
      a: 'Clear Vision lenses offer 12-16 hours of daily comfortable wear. However, individual performance may vary depending on eye conditions, environmental factors, and frequency of use.',
    },
    {
      q: 'Where are our clear lenses manufactured from?',
      a: 'They are proudly manufactured in Singapore',
    },
    {
      q: 'Do we offer trial clear lenses?',
      a: 'We do offer trial lenses for our Clear vision lenses. Visit our <a href="/stores/sg " class="faq-link">selected retail stores</a> to get them! <br/>Depending on your frequency choice we offer the following trials:<br/><div class="faq-bullet-point">Monthly Clear  - 1 Pair (2pcs) - 10 day usage</div> <div class="faq-bullet-point">Daily Clear - 5 pairs (10pcs) - 5 day usage</div> <div class="faq-bullet-point">Daily Blue - 5 pairs (10pcs) - 5 day usage</div>',
    },
    {
      q: 'Are there any contact lens deals?',
      a: 'Yes we do offer the following Bundle Deal Discounts:<br/><div class="faq-bullet-point">For Clear Vision Daily, Monthly and Blue</div> <div class="faq-bullet-point-sub">$10 Off for every 4 Boxes purchased</div> <div class="faq-bullet-point-sub">$30 Off for every 8 Boxes purchased</div> <div class="faq-bullet-point">For Colour lenses</div> <div class="faq-bullet-point-sub">Receive 1 box free for every 7 boxes purchased</div>',
    },
  ],
  colour: [
    {
      q: 'How long can I wear these colour lenses?',
      a: 'Horoscope and Petal lenses offer 8 hours of comfortable wear. However, individual performance may vary depending on eye conditions, environmental factors, and frequency of use.',
    },
    {
      q: 'Where are our colour lenses manufactured from?',
      a: 'They are manufactured in Korea',
    },
    {
      q: 'Do we offer trial colour lenses?',
      a: 'Currently, we do not offer trial lenses for our colour contacts',
    },
    {
      q: 'Are there any contact lens deals?',
      a: 'Yes we do offer the following Bundle Deal Discounts:<br/><div class="faq-bullet-point">For Clear Vision Daily, Monthly and Blue</div> <div class="faq-bullet-point-sub">$10 Off for every 4 Boxes purchased</div> <div class="faq-bullet-point-sub">$30 Off for every 8 Boxes purchased</div> <div class="faq-bullet-point">For Colour lenses</div> <div class="faq-bullet-point-sub">Receive 1 box free for every 7 boxes purchased</div>',
    },
  ],
  exchanges: [
    {
      q: 'When do we allow exchanges?',
      a: '<div class="faq-bullet-point">Manufacturing defects</div> <div class="faq-bullet-point">Prescription changes (Unopen boxes, more than 1 year of expiry)</div> <div class="faq-bullet-point">All exchanges has to be done in <a href="/stores/sg " class="faq-link">selected retail stores</a></div>',
    },
  ],
  delivery: [
    {
      q: 'Do you offer free shipping?',
      a: 'Yes, shipping is free for orders over S$50.',
    },
    {
      q: 'How long does delivery take?',
      a: '1-2 business days',
    },
  ],
};

export const FAQComponent = ({ baseImageUrl }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [openIdxs, setOpenIdxs] = useState([]);

  const faqs = FAQ_DATA[activeCategory] || [];

  const toggleIdx = idx => {
    setOpenIdxs(prev => (prev.includes(idx) ? prev.filter(i => i !== idx) : [...prev, idx]));
  };

  // Responsive: show both layouts, hide/show via CSS
  return (
    <div className="faq-root">
      {/* Desktop Layout */}
      <div className="faq-container faq-desktop">
        <h2 className="faq-title">FREQUENTLY ASKED QUESTIONS (FAQs)</h2>
        <div className="faq-content">
          <div className="faq-image-section">
            <img alt="FAQ visual" className="faq-image" src={`${baseImageUrl}/faq-image.webp`} />
          </div>
          <div className="faq-list-section">
            <div className="faq-tabs">
              {categories.map(cat => (
                <button
                  key={cat.value}
                  className={`faq-tab${activeCategory === cat.value ? ' active' : ''}`}
                  onClick={() => {
                    setActiveCategory(cat.value);
                    setOpenIdxs([]);
                  }}
                >
                  {cat.label}
                </button>
              ))}
            </div>
            <div className="faq-list">
              {faqs.map((faq, idx) => (
                <div
                  key={idx}
                  aria-label={openIdxs.includes(idx) ? 'Collapse' : 'Expand'}
                  className="faq-item"
                  role="button"
                  tabIndex={0}
                  onClick={() => toggleIdx(idx)}
                  onKeyPress={e => {
                    if (e.key === 'Enter' || e.key === ' ') toggleIdx(idx);
                  }}
                >
                  <div className="faq-item-content">
                    <span className="faq-question">{faq.q}</span>
                    <img
                      alt={openIdxs.includes(idx) ? 'Collapse' : 'Expand'}
                      className={`faq-plus-icon${openIdxs.includes(idx) ? ' open' : ''}`}
                      src={
                        openIdxs.includes(idx)
                          ? `${baseImageUrl}/faq-minus-icon.webp`
                          : `${baseImageUrl}/faq-plus-icon.webp`
                      }
                    />
                  </div>
                  {openIdxs.includes(idx) && (
                    <div dangerouslySetInnerHTML={{ __html: faq.a }} className="faq-answer" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="faq-mobile-container faq-mobile">
        <h2 className="faq-mobile-title">FAQs</h2>
        <div className="faq-mobile-tabs">
          {categories.map(cat => (
            <button
              key={cat.value}
              className={`faq-mobile-tab${activeCategory === cat.value ? ' active' : ''}`}
              onClick={() => {
                setActiveCategory(cat.value);
                setOpenIdxs([]);
              }}
            >
              {cat.label}
            </button>
          ))}
        </div>
        <div className="faq-mobile-list">
          {faqs.map((faq, idx) => (
            <div key={idx} className="faq-mobile-item">
              <div className="faq-mobile-item-content" onClick={() => toggleIdx(idx)}>
                <span className="faq-mobile-question">{faq.q}</span>
                <img
                  alt="Expand"
                  className={`faq-mobile-plus-icon${openIdxs.includes(idx) ? ' open' : ''}`}
                  src={`${baseImageUrl}/faq-arrow-sp.webp`}
                />
              </div>
              {openIdxs.includes(idx) && (
                <div dangerouslySetInnerHTML={{ __html: faq.a }} className="faq-mobile-answer" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
